/** Ant Design theme aligned with `src/styles/global.less` tokens */
export const careAntdTheme = {
  token: {
    colorPrimary: '#0d9488',
    colorSuccess: '#059669',
    colorWarning: '#d97706',
    colorError: '#dc2626',
    colorInfo: '#0891b2',
    colorTextBase: '#0f172a',
    colorTextSecondary: '#475569',
    colorTextTertiary: '#64748b',
    colorBorder: '#e2e8f0',
    colorBorderSecondary: '#f1f5f9',
    borderRadius: 10,
    fontFamily:
      "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
    fontSize: 14,
    controlHeight: 38,
    lineHeight: 1.55,
  },
  components: {
    Table: {
      headerBg: '#f1f5f9',
      headerColor: '#475569',
      headerSplitColor: 'transparent',
      rowHoverBg: '#f8fafc',
      borderColor: '#e8ecf1',
      cellPaddingBlock: 12,
      cellPaddingInline: 14,
    },
    Button: {
      primaryShadow: '0 2px 8px rgba(13, 148, 136, 0.28)',
      controlHeight: 40,
      fontWeight: 600,
    },
    Input: {
      activeBorderColor: '#0d9488',
      hoverBorderColor: '#5eead4',
      controlHeight: 40,
    },
    Pagination: {
      itemActiveBg: '#f0fdfa',
      borderRadius: 8,
    },
    Alert: {
      borderRadiusLG: 12,
    },
    Card: {
      borderRadiusLG: 16,
    },
    Tag: {
      borderRadiusSM: 6,
    },
  },
};
